var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 53,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 52.29,
    fill: "url(#paint0_linear_3601_675)",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "top-line",
    fill: "#14294E",
    d: "M20.33 18h3.84c1.25 0 2.49.01 3.73.07 1.26.06 2.51.11 3.77.14 1.1.02 2.21.05 3.31.04 1.05 0 2.1-.08 3.13-.12.73-.03 1.33.5 1.36 1.2a1.3 1.3 0 0 1-1.25 1.31c-1.21.05-2.43.12-3.65.12-1.28 0-2.55-.03-3.83-.07l-3.78-.15c-1.25-.05-2.5-.03-3.76-.02-1.1 0-2.19-.02-3.28 0-1.02-.02-2.03.04-3.04.15-.35.02-.69-.1-.94-.33a1.22 1.22 0 0 1-.07-1.77c.24-.24.56-.4.91-.41.46-.07.92-.1 1.4-.12.7-.04 1.43-.04 2.15-.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "middle-line",
    fill: "#14294E",
    d: "M34.67 24.77h-3.84c-1.25 0-2.49 0-3.74.06s-2.5.12-3.76.14c-1.1.03-2.21.05-3.32.04-1.04 0-2.08-.08-3.12-.12-.73-.03-1.34.5-1.37 1.2a1.3 1.3 0 0 0 1.26 1.32c1.21.04 2.43.12 3.65.12 1.28 0 2.55-.03 3.83-.07 1.26-.04 2.52-.11 3.78-.16 1.25-.04 2.5-.02 3.76-.01 1.09 0 2.18-.02 3.28-.01 1.01-.01 2.03.04 3.04.15.34.02.68-.1.94-.32.53-.47.56-1.26.07-1.78a1.42 1.42 0 0 0-.91-.4c-.46-.07-.93-.1-1.4-.13-.7-.03-1.43-.03-2.15-.03Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "bottom-line",
    fill: "#14294E",
    d: "M20.33 31.53h3.84c1.25 0 2.49 0 3.73.07 1.26.05 2.51.11 3.77.14 1.1.02 2.21.05 3.31.04 1.05-.01 2.1-.09 3.13-.12.73-.03 1.33.5 1.36 1.2a1.3 1.3 0 0 1-1.25 1.31c-1.21.05-2.43.12-3.65.12-1.28 0-2.55-.03-3.83-.07l-3.78-.15c-1.25-.05-2.5-.03-3.76-.02-1.1 0-2.19-.02-3.28 0-1.02-.02-2.03.04-3.04.15-.35.02-.69-.1-.94-.33a1.22 1.22 0 0 1-.07-1.77c.24-.24.56-.4.91-.41.46-.07.92-.1 1.4-.12.7-.04 1.43-.04 2.15-.04Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3601_675",
    x1: 0,
    x2: 53.27,
    y1: 44.86,
    y2: 7.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4D82E"
  })))));
};
export default SvgHamburgerMenu;